/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import { HELPERS } from '../../helpers/index.js';
import type { PromoteOutcomeSuggestionResponse, PromoteOutcomeSuggestionVars } from '../openapi-types.gen.js';

export type { PromoteOutcomeSuggestionResponse, PromoteOutcomeSuggestionVars } from '../openapi-types.gen.js';

export const usePromoteOutcomeSuggestion = createMutationHook<PromoteOutcomeSuggestionVars, PromoteOutcomeSuggestionResponse, unknown>({
  specName: 'usePromoteOutcomeSuggestion',
  path: '/v1/markets/{pubkey}/outcome-suggestions/{id}/promote',
  method: 'POST',
  resolveUrl: (vars: PromoteOutcomeSuggestionVars) => `/v1/markets/${vars.pubkey}/outcome-suggestions/${vars.id}/promote`,
  
  parseResponse: (raw: unknown): PromoteOutcomeSuggestionResponse => raw as PromoteOutcomeSuggestionResponse,
  optimistic: [{
    queryKey: ['markets', 'list'],
    apply: (prev: any, vars: PromoteOutcomeSuggestionVars, queryKey: readonly unknown[], queryClient: any) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = (HELPERS.markOutcomeSuggestionPromoting as unknown as (prev: any, vars: PromoteOutcomeSuggestionVars, queryKey: readonly unknown[], queryClient: any) => any)(next, vars, queryKey, queryClient);
      return next;
    },
  }],
  
  
});
